var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemBellFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M14.211 19.778a2.223 2.223 0 0 1-4.444 0ZM11.99 2A1.11 1.11 0 0 1 13.1 3.111v.096c3.406.534 6.013 3.473 6.013 7.029v5.097l1.437 1.437c.7.7.204 1.897-.786 1.897H4.214c-.99 0-1.486-1.197-.786-1.897l1.436-1.437v-5.097c0-3.556 2.608-6.495 6.014-7.03v-.095A1.11 1.11 0 0 1 11.988 2"
})));
export default SvgGemBellFill;